<template>
    <div class="animated fadeIn">
        <b-card>
            <template v-slot:header>
                <h5>Banner Mobile</h5>
            </template>
            <div class="form-content-wrapper mb-4">  
                <div class="search-wrapper d-flex align-items-center justify-content-between">
                    <div class="d-flex form-content-wrapper mb-4">
                        <b-form-group class="mr-2 mb-0">
                            <b-form-input v-model="filter.judul" v-on:keyup.enter="getItems()" placeholder="Judul" />
                        </b-form-group>
                        <b-form-group class="mr-2 mb-0">
                            <b-form-select v-model="filter.isActive">
                                <b-form-select-option value=0>Semua Banner</b-form-select-option>
                                <b-form-select-option value=1>Hanya Banner Aktif</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                        <b-button variant="pgiBtn" name="searchTableBtn" @click="getItems()"> 
                            <b-spinner small class="loading-spinner" v-if="isBusy"></b-spinner>
                            <i class="fa fa-search" v-else></i>
                        </b-button>
                    </div>
                    <div class="mb-4">
                        <router-link to="/master/banner-mobile/create">
                            <b-button variant="pgiBtn">Input Banner Baru</b-button>
                        </router-link>
                    </div>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <b-table bordered hover show-empty
                        :busy="isBusy"
                        :items="items" 
                        :fields="fields" 
                        responsive class="mb-3"
                    >
                        <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Mengambil data...</strong>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data banner.
                        </template>
                        <template v-slot:cell(urutan)="row">
                            <div v-if="row.item.urutan == null" class="text-muted">
                                Tidak Aktif
                            </div>
                            <div v-else class="font-weight-bold">
                                {{ row.item.urutan }}
                            </div>
                        </template>
                        <template v-slot:cell(judul)="row">
                            {{ row.item.judul }}
                            <div class="small">{{ $helper.changeDateFormat(row.item.createdAt) }}, {{ $helper.changeDateFormatGetHour(row.item.createdAt) }}</div>
                        </template>
                        <template v-slot:cell(action)="row">
                            <a :href="$baseFilePath + row.item.photo" target="_blank">
                                <b-button variant="primary" class="mr-2" size="sm" v-b-tooltip.hover title="Lihat Foto Banner">
                                    <i class="fa fa-fw fa-photo" />
                                </b-button>
                            </a>
                            <router-link :to="'/master/banner-mobile/' + row.item.id">
                                <b-button variant="primary" class="mr-2" size="sm" v-b-tooltip.hover title="Detail">
                                    <i class="fa fa-fw fa-info" />
                                </b-button>
                            </router-link>
                            <b-button v-if="row.item.urutan == null" variant="success" size="sm" v-b-tooltip.hover title="Aktivasi" @click="setActive(row.item)">
                                <i class="fa fa-fw fa-power-off" />
                            </b-button>
                            <b-button v-if="row.item.urutan != null" variant="danger" size="sm" v-b-tooltip.hover title="Non-aktivasi" @click="setInactive(row.item)">
                                <i class="fa fa-fw fa-power-off" />
                            </b-button>
                        </template>
                    </b-table>
                    <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                        <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                            <b-form-select v-model="show" @change="onLimitChange" :options="options">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled />
                                </template>
                            </b-form-select>
                            <span class="ml-2">{{ totalViewText }}</span>
                        </b-input-group>
                        <b-pagination class="mb-0"
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            aria-controls="my-table"
                            @input="onPageChange"
                        ></b-pagination>
                    </div>
                </div>
            </div>
        </b-card>
        <b-modal id="modal-set-active" title="Set Banner Aktif" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Mengaktifkan banner dengan judul <strong>{{ activeItem.judul }}</strong>.
            <b-form-group label="Letakan banner ini..." class="mt-4">
                <b-form-select v-model="input.urutan" :options="optActiveBanners">
                    <template v-slot:first>
                        <b-form-select-option value=1>Di Depan</b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group> 
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execSetActive">
                    {{ isSubmitting ? "Menyimpan..." : "Aktifkan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-set-inactive" title="Nonaktifkan Banner" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Nonaktifkan banner dengan judul <strong>{{ activeItem.judul }}</strong>?
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execSetInactive">
                    {{ isSubmitting ? "Memproses..." : "Nonaktifkan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    name: 'banner-mobile',
    data() {
        return {

            isBusy: false,
            isSubmitting: false,
            show: 1,

            filter: {
                judul: "",
                isActive: 0
            },

            input: {
                urutan: 1
            },

            options: [
                { value: 1, text: '10'},
                { value: 2, text: '20'},
                { value: 3, text: '30'},
                { value: 4, text: '40'},
                { value: 5, text: '50'},
            ],

            fields: [
                { key: "judul", label: "Judul / Tgl. Pembuatan" },
                { key: "urutan", label: "Urutan Banner" },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {},
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,
            totalViewText: "",

            optActiveBanners: []

        }
    }, 

    methods: {

        getActiveBanners() {

            this.$axios.get("banner-mobile/active").then(res => {
                
                let banners = res.data.map(it => {
                    return { value: it.id + 1, text: `Setelah ${it.name}` }
                })

                this.optActiveBanners = banners

            })
            .catch(error => this.$helper.parseError(this, error))

        },

        getItems(page = 1) {

            let query = ""

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)

            if(!this.$helper.isNullOrEmpty(this.filter.judul)) {
                param += "&filterJudul=" + this.filter.judul
            }

            if(this.filter.isActive != 0) {
                param += "&filterActive=true"
            }

            return this.$axios.get("banner-mobile/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

                let pg = this.currentPage - 1

                let prev = pg * this.show + 1
                let limit = pg * this.show + this.show
                if (limit > this.totalRows) limit = this.totalRows

                this.totalViewText = "Menampilkan "+ prev + " - " + limit + " dari " + this.totalRows + " entri"

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        setActive(item) {
            this.activeItem = item
            this.$bvModal.show("modal-set-active")
        },

        setInactive(item) {
            this.activeItem = item
            this.$bvModal.show("modal-set-inactive")
        },

        execSetActive() {

            let payload = new FormData()
            payload.append("bannerId", this.activeItem.id)
            payload.append("urutan", this.input.urutan)

            this.isSubmitting = true
            this.$axios.post("banner-mobile/set-active", payload).then(res => {

                this.input.urutan = 1
                this.$helper.toastSucc(this, `Banner '${this.activeItem.judul}' berhasil diaktifkan!`)

                this.getItems()
                this.getActiveBanners()
                this.$bvModal.hide("modal-set-active")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        execSetInactive() {
            
            let payload = new FormData()
            payload.append("bannerId", this.activeItem.id)

            this.isSubmitting = true
            this.$axios.post("banner-mobile/set-inactive", payload).then(res => {

                this.$helper.toastSucc(this, `Banner '${this.activeItem.judul}' berhasil dinonaktifkan!`)

                this.getItems()
                this.getActiveBanners()
                this.$bvModal.hide("modal-set-inactive")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

    },

    created() {
        this.getItems()
        this.getActiveBanners()
    }

}
</script>
